import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { quickAccessFeature } from '../base/menu/quick-access/quick-access-reducers';
import * as BlueSageSettlementEffects from '../bluesage/bluesage-settlement.effects';
import * as BlueSageTerminalPickerEffects from '../bluesage/terminal-picker/bluesage-terminal-picker.effects';
import { blueSageTerminalPickerFeature } from '../bluesage/terminal-picker/bluesage-terminal-picker.feature';
import * as BlueSageTerminalPushEffects from '../bluesage/terminal-push/bluesage-terminal-push.effects';
import { blueSageTerminalPushFeature } from '../bluesage/terminal-push/bluesage-terminal-push.feature';
import { authFeature } from '../core/auth/auth.reducer';

import { zonesFeature } from '../core/zones/zones.reducer';
import * as NavigatorOutboxEffects from '../job/job-navigator/navigator-outbox/navigator-outbox.effects';
import { navigatorOutboxFeature } from '../job/job-navigator/navigator-outbox/navigator-outbox.reducer';
import { jobToolFeature } from '../job/job-tool.reducer';
import * as MutateObjectEffects from '../job/mutate-object/mutate-object.effects';
import { jobsFeature } from '../jobs/jobs.reducer';

import * as QuickJsEffects from '../quickjs/quickjs.effects';
import { quickjsFeature } from '../quickjs/quickjs.feature';
import * as CancelAndCloseDialogEffects from '../shared/cancel-and-close-dialog/cancel-and-close-dialog.effects';
import { cancelAndCloseDialogFeature } from '../shared/cancel-and-close-dialog/cancel-and-close-dialog.reducer';
import * as CreateDocumentDialogEffects from '../shared/create-document-dialog/create-document-dialog.effects';
import { createDocumentDialogFeature } from '../shared/create-document-dialog/create-document-dialog.feature';
import { documentTypesFeature } from '../shared/create-document-dialog/document-types';

import * as ActionNotificationEffects from '../state/action-notifications.effects';
import * as PersistStateEffects from '../state/persist-state.effects';
import * as PropagateEffects from '../state/propagate.effects';
import { templatesFeature } from '../templates/state/templates.store';
import * as CancelPayLinkDialogEffects from '../transactions/cancel-pay-link-dialog/cancel-pay-link-dialog.effects';
import { cancelPayLinkDialogFeature } from '../transactions/cancel-pay-link-dialog/cancel-pay-link-dialog.feature';
import * as CancelPreauthDialogEffects from '../transactions/cancel-preauth-dialog/cancel-preauth-dialog.effects';
import { cancelPreauthDialogFeature } from '../transactions/cancel-preauth-dialog/cancel-preauth-dialog.feature';
import * as CreateTransactionDialogEffects from '../transactions/create-transaction-dialog/create-transaction-dialog.effects';
import { createTransactionDialogFeature } from '../transactions/create-transaction-dialog/create-transaction-dialog.feature';
import * as PayInvoiceEffects from '../transactions/pay-invoice.effects';

import { brandingFeature } from './branding.store';
import { featureFlagsFeature } from './featureFlags.store';
import * as UnsavedChangesEffects from './unsaved-changes.effects';
import { unsavedChangesFeature } from './unsaved-changes.reducer';

export const rootState = [
  provideState(authFeature),
  provideState(brandingFeature),
  provideState(featureFlagsFeature),
  provideState(zonesFeature),
  provideState(quickjsFeature),
  provideState(quickAccessFeature),
  provideState(unsavedChangesFeature),
  provideState(jobsFeature),
  provideState(templatesFeature),
  provideState(jobToolFeature),

  // App-wide, not on the navigator page: the crew's waiting saves are sent from wherever the app is
  // when the signal returns (#86a).
  provideState(navigatorOutboxFeature),
  provideEffects(NavigatorOutboxEffects),

  // The Create Transaction dialog is mounted on the app shell, not on the job
  // page: every button that creates a transaction opens it, including the
  // dispatch board's and the invoice details panel's, and those render over
  // pages that provide nothing job-shaped.
  provideState(blueSageTerminalPickerFeature),
  provideState(blueSageTerminalPushFeature),
  provideState(createTransactionDialogFeature),
  provideState(cancelPayLinkDialogFeature),
  provideState(cancelPreauthDialogFeature),
  provideState(createDocumentDialogFeature),
  provideState(documentTypesFeature),
  provideEffects(
    CreateTransactionDialogEffects,
    CreateDocumentDialogEffects,
    CancelPayLinkDialogEffects,
    CancelPreauthDialogEffects,
    BlueSageTerminalPickerEffects,
    BlueSageTerminalPushEffects,
    BlueSageSettlementEffects,
  ),

  provideEffects(QuickJsEffects),
  provideEffects(PersistStateEffects),
  provideEffects(UnsavedChangesEffects),
  provideEffects(ActionNotificationEffects),
  provideEffects(PropagateEffects),
  provideEffects(MutateObjectEffects),
  provideEffects(PayInvoiceEffects),
  provideState(cancelAndCloseDialogFeature),
  provideEffects(CancelAndCloseDialogEffects),
];
